import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-af8443e2")

_pushScopeId("data-v-af8443e2")
const _hoisted_1 = { class: "dt-open-api-api-content" }
const _hoisted_2 = { class: "dt-open-api-api-content-title" }
const _hoisted_3 = { class: "dt-open-api-api-table" }
const _hoisted_4 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", null, "接口名称"),
    /*#__PURE__*/_createVNode("th", null, "接口地址"),
    /*#__PURE__*/_createVNode("th", null, "请求方式"),
    /*#__PURE__*/_createVNode("th", null, "版本号"),
    /*#__PURE__*/_createVNode("th", null, "更新时间"),
    /*#__PURE__*/_createVNode("th", null, "介绍")
  ])
], -1)
const _hoisted_5 = { style: {"text-align":"center"} }
const _hoisted_6 = { style: {"text-align":"center"} }
const _hoisted_7 = { style: {"text-align":"center"} }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("p", _hoisted_2, _toDisplayString(_ctx.groupname), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("table", null, [
        _hoisted_4,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.apis, (item) => {
          return (_openBlock(), _createBlock("tr", {
            key: item.id
          }, [
            _createVNode("td", {
              onClick: $event => (_ctx.lookApiInfo(item.id))
            }, _toDisplayString(item.title), 9, ["onClick"]),
            _createVNode("td", null, _toDisplayString(item.url), 1),
            _createVNode("td", _hoisted_5, _toDisplayString(item.method), 1),
            _createVNode("td", _hoisted_6, _toDisplayString(_ctx.getVersion(item.version)), 1),
            _createVNode("td", _hoisted_7, _toDisplayString(item.updateTime.split(' ')[0]), 1),
            _createVNode("td", null, _toDisplayString(item.description), 1)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
})